module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0103.jpg?v=2db3ea25";